import {
  GET_VOLCANO_EVENTS_REQUEST,
  CLEAR_VOLCANO_EVENTS,
  CLEAR_VOLCANO_EVENT_REDIRECT,
  GET_VOLCANO_EVENT_COUNTRY_REQUEST,
  GET_VOLCANO_EVENT_REGION_REQUEST,
  GET_VOLCANO_EVENT_NAME_REQUEST,
  GET_VOLCANO_EVENT_MORPHOLOGY_REQUEST,
} from './volcanoEventSearchReducer';
import {
  VOLCANO_EVENT_SEARCH_TOGGLE_HAZ_ASSOC,
  VOLCANO_EVENT_SEARCH_TOGGLE_VOL_EFFECTS,
  VOLCANO_EVENT_SEARCH_TOGGLE_VOL_PARAMS,
} from './volcanoEventSearchPageReducer';


export const getVolcanoEvents = ({
  queryParameters, formModel, location, searchRedirect, history,
}) => ({
  type: GET_VOLCANO_EVENTS_REQUEST, queryParameters, formModel, location, searchRedirect, history,
});
export const clearVolcanoEvents = () => ({ type: CLEAR_VOLCANO_EVENTS });

export const clearVolcanoEventRedirect = () => ({ type: CLEAR_VOLCANO_EVENT_REDIRECT });

export const toggleVolcanoParams = () => ({ type: VOLCANO_EVENT_SEARCH_TOGGLE_VOL_PARAMS });
export const toggleVolcanoEffects = () => ({ type: VOLCANO_EVENT_SEARCH_TOGGLE_VOL_EFFECTS });
export const toggleHazardAssociations = () => ({ type: VOLCANO_EVENT_SEARCH_TOGGLE_HAZ_ASSOC });

export const getCountries = ({ history }) => ({ type: GET_VOLCANO_EVENT_COUNTRY_REQUEST, history });
export const getRegions = ({ history }) => ({ type: GET_VOLCANO_EVENT_REGION_REQUEST, history });
export const getVolcanoNames = ({ history }) => ({ type: GET_VOLCANO_EVENT_NAME_REQUEST, history });
export const getMorphologies = ({ history }) => ({ type: GET_VOLCANO_EVENT_MORPHOLOGY_REQUEST, history });
